import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//import Navbar from './components/navbar';
import 'bootstrap/dist/css/bootstrap.min.css'
import App3 from './App3';

const element = <h1>Hello world</h1>;
const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<Navbar/>);

root.render(
  <React.StrictMode>
    <App3 />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

